export const usdtContractAddress = "0x55d398326f99059fF775485246999027B3197955";
export const nftPresaleContractAddress = "0x7aC43b95E7181b0eA8805efd4905Dce0a96373e7";